import { enumBlockerNextAction, useBlockerContext } from "@/providers/BlockerProvider";
import { useEffect, useRef } from "react";

export type TopicBlocker = (payload?: unknown) =>
  | { doBlock: false }
  | {
      doBlock: true;
      alertParams: {
        title: string;
        message: string;
        confirmText: string;
        onConfirm?: () => void | Promise<void> | enumBlockerNextAction;
        denyText: string;
        onDeny?: () => void | Promise<void> | enumBlockerNextAction;
      };
    };

export const useTopicBlocker = (topic: string, blocker: TopicBlocker) => {
  const { registerBlocker } = useBlockerContext();

  const blockerRef = useRef<TopicBlocker>(blocker);
  blockerRef.current = blocker;

  useEffect(() => {
    return registerBlocker(topic, (payload: unknown) => {
      return blockerRef.current?.(payload);
    });
  }, []);
};
